export const TIME_5000 = 20000;
